import React, { JSX } from 'react';
import { Flex } from '@chakra-ui/react';

export const ExpandableSection = ({ children }: { children: React.ReactNode }): JSX.Element => (
  <Flex direction="column">{children}</Flex>
);
